import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// Country names come from the platform's CLDR data via Intl.DisplayNames, so
// all 32 destinations localise without maintaining a name list per language.
export const useCountryName = () => {
    const { i18n } = useTranslation();
    return useMemo(() => {
        let display;
        try {
            display = new Intl.DisplayNames([i18n.language], { type: "region" });
        } catch {
            display = null;
        }
        return (code, fallback) => {
            try {
                return display?.of(code.toUpperCase()) || fallback;
            } catch {
                return fallback;
            }
        };
    }, [i18n.language]);
};
